export const DASHBOARD_VIEW_MODE = Object.freeze({
  LIST: 'list',
  GRID: 'grid',
});
